// Effect Managers
import { put, select, call } from 'redux-saga/effects'

// Exports
export default function composeHandleDelete ({
  actionCreators,
  url,
  token$,
  handleFetch,
}) {
  return function *handleDelete ({url: maybeUrl, queryParams, id}) {
    const token = yield select(token$)

    const options = yield {
      url: maybeUrl || url,
      token,
      queryParams,
      id,
      method: 'DELETE',
    }

    yield put(actionCreators.deleting({
      queryParams,
      id,
    }))

    const { bad, status, response } = yield call(handleFetch, options)

    if (bad) {
      yield put(actionCreators.failDelete({
        id,
        queryParams,
        response,
        status,
      }))
    } else {
      yield put(actionCreators.deleted({
        id,
        queryParams,
        status,
      }))
    }

    return { status, response, id, error: bad }
  }
}
